<template>
    <v-card min-width="25vw" align="center" justify="center" outlined>
        <v-card-title>
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title_EditReferredFrom') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-5 pt-5">
           <v-container fluid>
              <v-row class="my-2">
                <div>
                  <p>{{ $t('prependMessage_EditReferredFrom') }} <b>{{ this.referred }}</b> {{ $t('appendMessage') }}</p>
                  <p>{{ $t('finalMessage') }}</p>
                </div>
              </v-row>
              <v-row class="my-2" align="center" justify="center">
                  <v-btn @click="closeWindow">{{ $t('btnCancel_EditReferredFrom') }}</v-btn>
                  <v-btn class="ml-5" @click="addReferredFrom">{{ $t('btnAdd') }} <v-icon class="ml-2" small>fa-user-plus</v-icon></v-btn>
              </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import AuthRepository from '../../../repositories/auth';
import { mapMutations } from 'vuex';

export default {
    props: {
        referred: String,
    },
    name: "EditReferredFrom",
    methods: {
        ...mapMutations(['setNewProfile']),
        addReferredFrom(){
            let newProfileData = {
                firstName: this.$store.state.user.firstName,
                lastName: this.$store.state.user.lastName,
                username: this.$store.state.user.username,
                phoneNumber: this.$store.state.user.details.phoneNumber,
                description: this.$store.state.user.details.profileDescription,
                referredFrom: this.referred,
            };

            AuthRepository.editProfile(newProfileData).then((response) => {
                if(response.status < 400 && response.data) {
                    this.setNewProfile(newProfileData);
                    alert(`${this.referred} was successfully added as your referred!`);
                }
            });
            this.closeWindow();
        },
        closeWindow() {
            this.$emit('closeWindow');
        },
    }
}
</script>



<style>

</style>
